(function () {
    'use strict';


    angular
        .module('trainingDiscrepancy')
        .factory('TrainingDiscrepancyRequestFactory', TrainingDiscrepancyRequestFactory);
    function TrainingDiscrepancyRequestFactory() {



    	function SearchDTO() {
            this.aircraftType=null;
            this.category = null;
            this.startDate = null;
            this.endDate = null;
            this.pageSize=null;
            this.location=null;
            this.startPosition=null;
        }


    	function GetSearchCriteria(){
    		return new SearchDTO();
    	}

        function getTrackingSuggestionRequest(params) {
            return params.trainingSlotID
        }

        return {
        	getSearchCriteria   : GetSearchCriteria,
            trackingSuggestionRequest: getTrackingSuggestionRequest
        }

    }
})();
